import { render, staticRenderFns } from "./youtube-video.vue?vue&type=template&id=3fe6a1ec&scoped=true&"
import script from "./youtube-video.vue?vue&type=script&lang=ts&"
export * from "./youtube-video.vue?vue&type=script&lang=ts&"
import style0 from "./youtube-video.vue?vue&type=style&index=0&id=3fe6a1ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe6a1ec",
  null
  
)

export default component.exports